/**
 * Created by jahidul.hasan on 1/25/2021.
 */
import {EventEmitter, Injectable} from '@angular/core';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {Subject} from 'rxjs';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {CommandService} from '@core/services/command.service';
import {Router} from '@angular/router';
import {DialogService} from '@shared/services/dialog-service';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {PlatformCommand} from '@shared/commands/command-base';
import {take} from 'rxjs/operators';
import {takeUntil} from 'rxjs/operators';
import {GraphqlContentScope} from "@shared/models/graphql-content-scope.model";
import {TaskManagerService} from "./task-manager.service";
import {TaskMenuDetails} from "../models/task-manager.model";
import {DialogModel} from "@shared/models/dialog.model";
import {ActivityFilterSettings} from "@shared/models/activity-tracker-header.model";

@Injectable({
  providedIn: 'root',
})

export class ActivityTrackerViewHandler implements IPlatformToolHandler {
  magicLinkModelValueChanged: EventEmitter<any> = new EventEmitter();
  magicLinkModel: MagicLinkModel;
  private selectedTabModel: TabModel;
  ngUnsubscribe = new Subject<void>();
  invalidateSubject: InvalidateSubject;

  constructor(private commandService: CommandService,
              private router: Router,
              private dialogService: DialogService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private snackBarService: SnackBarService,
              private taskManagerService: TaskManagerService
  ) {
  }

  executeCommand(command: PlatformCommand) {
    console.log('[activity-tracker-platform-command] onPlatformTool Handler Command', command);
    switch (command.name) {
      case 'SaveActivityFilterCommand':
        this.magicLinkModelValueChangedHandler({name: command.name, command: command});
        break;
      case 'ActivityTrackerTaskCommand':
        this.openTask(command);
        break;
      case 'DateFilterCommand':
        this.magicLinkModelValueChangedHandler({name: command.name, command: command});
        break;
      case 'AuditTrailCommand':
        this.magicLinkModelValueChangedHandler({name: command.name, command: command});
        break;
      case 'ExportActivityCommand':
        this.magicLinkModelValueChangedHandler({name: command.name, command: command});
        break;
      case 'CreateFilterCommand':
        this.crateFilter(command);
        return true;
      default:
        this.executeCommandToApi(command);
        break;
    }
  }

  private crateFilter(command: PlatformCommand) {
    console.log('crate filter:', command);
    this.executeCommandToApi(command);
  }

  private openTask(command: PlatformCommand) {
    this.taskManagerService.openTaskByTaskId(command.fieldValues['TicketDisplayId'], 'COMPANY').pipe(takeUntil(this.ngUnsubscribe)).subscribe(state => { });
  }

  private magicLinkModelValueChangedHandler(command: any) {
    this.magicLinkModelValueChanged.emit(command);
  }

  private executeCommandToApi(command: PlatformCommand) {
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          console.log('Command Response', commandResponse);
          this.fuseSplashScreenService.hide();
          if (commandResponse.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
          }
          if (commandResponse.fieldValues['SnackBarMessage']) {
            const duration = commandResponse.fieldValues['SnackBarMessage'].length * 80;
            this.snackBarService.showInformation(commandResponse.fieldValues['SnackBarMessage'], duration);
          }
          this.invalidateSubject.invalidate();
        },
        error => {
          this.fuseSplashScreenService.hide();
        });
    }
  }

  valueChanged($event) {
    console.log('Inside Handler', $event);
    if (this.handleAction($event)) {
      return;
    }
    if (this.handleCommand($event)) {
      return;
    }
    if ($event.item && $event.fieldDefinition && $event.fieldSection) {
      switch ($event.fieldSection.id) {
        default:
          return;
      }
    }
  }

  private handleCommand($event): boolean {
    if ($event.command) {
      switch ($event.command.name) {
        default:
          this.executeCommand($event.command);
          return true;
      }
    }
    return false;
  }

  private handleAction($event): boolean {
    if (this.selectedTabModel && $event.action) {
      switch ($event.action.id) {
        case 'InvalidateActivityTrackerView':
          this.invalidateActivityTrackerView($event.item, $event.filterSettings);
          return true;
        case 'InvalidateActivityTrackerViewRoute':
          this.InvalidateActivityTrackerViewRoute($event.item);
          return true;
        case 'FilterSettingChanges':
          this.dispatchFilterSettingChanges($event.action.id, $event.filterSettings);
          return true;
      }
    }
    return false;
  }

  setSelectedTab(selectedTab: TabModel): void {
    this.selectedTabModel = selectedTab;
  }

  destroy() {
    this.invalidateSubject.close();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }


  private invalidateActivityTrackerView(item: any, filterSettings: ActivityFilterSettings) {
    const command = new PlatformCommand('CreateActivityTrackerViewCommand', 'CollaborationApi');
    command.fieldValues['Type'] = item.type;
    command.fieldValues['Id'] = item.id;
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(response => {
        console.log('commandState', response);
        if (response.fieldValues['PlatformLinkModel']) {
          this.magicLinkModelValueChangedHandler({id: 'PlatformToolContainerComponent', value: response.fieldValues['PlatformLinkModel']});
          this.handleAction({action: {id: 'FilterSettingChanges'}, filterSettings: filterSettings});
        } else {
          console.log('Platform link model not found');
        }
      },
      error => {
        this.fuseSplashScreenService.hide();
        console.error('Operation failed!!!', error);
      });
  }

  private dispatchFilterSettingChanges(name: string, filterSettings: ActivityFilterSettings) {
    this.magicLinkModelValueChangedHandler({name: name, filterSettings: filterSettings});
  }

  private InvalidateActivityTrackerViewRoute(item) {
    let filterRoute = `activities/filter/${item.id}`;
    console.log('[]filter route:', filterRoute);
    this.router.navigateByUrl(filterRoute);
  }
}
